module.exports = __webpack_public_path__ + "static/media/peroni-512.8fcbbf9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni-512.png
// module id = 782
// module chunks = 0